/**
 * Web noop as there is no "startup" to time from the native layer.
 */

export default {
    stop() {},
};
